import { render, staticRenderFns } from "./ChannelThumbnail.vue?vue&type=template&id=efd1b2b4&scoped=true"
import script from "./ChannelThumbnail.vue?vue&type=script&lang=js"
export * from "./ChannelThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ChannelThumbnail.vue?vue&type=style&index=0&id=efd1b2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_webpack@5.104.1__lodash@4.17.23_react-dom@16.14.0_r_74e494c6076ab34d677e70338ea024d9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd1b2b4",
  null
  
)

export default component.exports